// ResponsiveRetourVente.jsx → src/gestion-retour-vente/
import React from "react";
import GestionRetourVente from "./GestionRetourVente";
import RetoursVenteMobile from "../mobile/ventes/RetoursVenteMobile";
import useIsMobile from "../hooks/useIsMobile";

export default function ResponsiveRetourVente(props) {
  return useIsMobile() ? <RetoursVenteMobile {...props} /> : <GestionRetourVente {...props} />;
}
